import React, { useState, useEffect, useRef, useCallback } from "react";

import { Button } from "semantic-ui-react";
import { ITableAppRender } from "../../components/TableApp";
import TemplateTable from "../../components/TemplateTable";

import { ISearch } from "../../components/Search";
import { ISearchResponse } from "../../interfaces"

import CadastrarEntrada from "./CadastrarEntrada";
import DetalharEntrada from "./DetalharEntrada";
import errors from "../../Utils/ExtractErrors";
import { toast } from "react-toastify";
import { GetUser } from "../../services/auth";
import PaymentsRepository, { IEntradasListModel } from "../../Repositories/PaymentsRepository";
import { format } from "date-fns";
import NumberFormat from "../../Utils/NumberFormat";
import ModalYesNo from "../../components/ModalYesNo";

const Payments: React.FC = () => {

    const [list, setList] = useState<IEntradasListModel[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const refSearch = useRef<ISearch>({ searchString: "", type: "simples" });
    const refRecordsByPage = useRef<number>(20);
    const refPageNumber = useRef<string | number | undefined>(1);
    const refTotalRecords = useRef<number>(0);
    const refTotalPages = useRef<number>(1);

    const { role } = GetUser();

    const onChangeRecords = (value: number) => {
        refRecordsByPage.current = value;
        load();
    }

    const onPageChange = (pageNumber: string | number | undefined) => {
        refPageNumber.current = pageNumber;
        load();
    }

    const onDelete = async (id: string) => {
        try {

            await PaymentsRepository.Delete(id);

            toast(`❌ Entrada apagada com sucesso.`, { position: "top-center", type: "success" });
            load();
        } catch (error) {
            return toast("❌ Erro ao apagar a entrada.", { position: "top-center", type: "error" });
        }
    }

    const load = useCallback(async () => {
        setLoading(true);
        try {

            let response: ISearchResponse<IEntradasListModel>;
            if (refSearch.current.type === "simples") {
                response = await PaymentsRepository.List({
                    search: refSearch.current.searchString,
                    pageNumber: refPageNumber.current,
                    recordsByPage: refRecordsByPage.current
                });
            } else {
                response = await PaymentsRepository.List({
                    search: refSearch.current.searchString,
                    pageNumber: refPageNumber.current,
                    recordsByPage: refRecordsByPage.current
                });
            }

            refTotalRecords.current = response.totalRecords;
            refTotalPages.current = response.totalPages;

            setList(response.list);
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }

        setLoading(false);
    }, []);

    const onSearch = ({ searchString, type }: ISearch) => {
        refSearch.current.searchString = searchString;
        refSearch.current.type = type;

        load();
    }

    useEffect(() => { load() }, [load]);

    const tableRender: ITableAppRender[] = [
        {
            header: "Data do Comprovante",
            content: (x: IEntradasListModel) => format(new Date(x.dataComprovante), "dd/MM/yyyy"),
            textAlign: "left",
            width: 3
        },
        {
            header: "G. Regional",
            content: (x: IEntradasListModel) => x.gerenteRegional.split(" ")[0],
            textAlign: "left",
            width: 2
        },
        {
            header: "G. Setor",
            content: (x: IEntradasListModel) => x.gerenteSetor,
            textAlign: "center",
            width: 4
        },
        {
            header: "Representante",
            content: (x: IEntradasListModel) => x.representante,
            textAlign: "left",
            width: 4
        },
        {
            header: "Valor R$",
            content: (x: IEntradasListModel) => NumberFormat.Currency(x.valorEntrada),
            width: 1
        }
    ];


    return (
        <TemplateTable
            title="Entradas"
            icon="plus"
            insert={<CadastrarEntrada onSuccess={load} />}
            searchPlaceHolder={"Nome"}
            onSearch={onSearch}
            tableLoading={loading}
            tableRender={tableRender}
            tableList={list}
            tableActions={(data: IEntradasListModel, index: number) =>
                (role === "Admin") ? [
                    <DetalharEntrada key={data.id || ""} entradaId={data.id || ""} onSuccess={load} />,
                    <ModalYesNo
                        trigger={
                            role === "Admin" &&
                            <Button
                                icon="trash"
                                color="red"
                            />
                        }
                        header="Apagar Entrada"
                        content={`Deseja realmente apagar a entrada de ${data.representante} no valor de ${NumberFormat.Currency(data.valorEntrada)}?`}
                        onSuccess={() => onDelete(data.id || "")}
                    />
                ] : []
            }
            tablePagination={{
                currentPage: refPageNumber.current,
                totalRecords: refTotalRecords.current,
                totalPages: refTotalPages.current,
                onPageChange: onPageChange
            }}
            tableOnChangeRecords={onChangeRecords}
        />
    );
};

export default Payments;
